export default __webpack_public_path__ + "static/media/b3fe18d4c0d28d448f6c7b08cb48339e.png";